import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import Retaileruploadstock from "../retailer/Retaileruploadstock";

// Stock upload for the operations role. The pharmacy portal already has the
// full upload / column-mapping / matching flow, so this screen only picks which
// pharmacy the stock belongs to and reuses that screen for the rest.
export default class StockUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      selectedRetailerId: "",
      isLoading: true,
    };
  }

  componentDidMount() {
    this.fetchRetailers();
  }

  //  Pharmacy list for the dropdown
  fetchRetailers() {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/")
      .then((response) => {
        const retailers = response.data.data || [];
        this.setState({ retailers: retailers, isLoading: false });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoading: false });
      });
  }

  handleRetailerChange = (event) => {
    this.setState({ selectedRetailerId: event.target.value });
  };

  render() {
    const { retailers, selectedRetailerId, isLoading } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link>&gt;Order Medicine &gt;
                      Stock Upload
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3> Stock Upload </h3>
                      </div>
                      <div id="reg_form">
                        <div className="row">
                          <div className="form-group col-md-4">
                            <label>Pharmacy</label>
                            <select
                              className="form-control"
                              value={selectedRetailerId}
                              onChange={this.handleRetailerChange}
                            >
                              <option value="">
                                {isLoading
                                  ? "Loading pharmacies..."
                                  : "Select Pharmacy"}
                              </option>
                              {retailers.map((retailer) => (
                                <option key={retailer.id} value={retailer.id}>
                                  {retailer.storename}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {!isLoading && retailers.length === 0 && (
                          <p className="cRed">
                            No pharmacies available to upload stock for.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {selectedRetailerId ? (
                <Retaileruploadstock
                  key={selectedRetailerId}
                  retailerId={selectedRetailerId}
                  embedded
                />
              ) : (
                <p style={{ paddingLeft: "15px" }}>
                  Select a pharmacy to upload its stock file.
                </p>
              )}
              <ToastContainer />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
